export const handbookCopy = {
  handb_prev: "戻る",
  handb_next: "次へ",
  handb_on_this_page: "このページ",
  handb_like_dislike_title: "このページは役に立ちましたか?",
  handb_like_desc: "はい",
  handb_dislike_desc: "いいえ",
  handb_thanks: "ありがとうございます。",
}
